import * as _ from 'lodash';

class SavingsPuckFacilitiesCtrl {
  account;
  rfp;
  puck;
  offerId;
  tierId;
  facilities;
  usePrimaryEquivalentCrosses;

  maxRowsToShow = 7;

  gridOptions: any = {
    minRowsToShow: 10,
    enableColumnMenus: false,
    enableHorizontalScrollbar: this.uiGridConstants.scrollbars.NEVER,
    // rowHeight: 56,
    columnDefs: [
      {
        displayName: 'Facilities',
        field: 'name',
        cellTemplate:
          '<div class="ui-grid-cell-contents">{{ COL_FIELD.trim() }}</div>',
        headerCellClass: 'facilityName'
      },
      {
        displayName: 'Spend with Me (Last 12 Months)',
        field: 'categorySpend.spendWithSeller', // show this on seller side only
        // cellTemplate: '<div class="ui-grid-cell-contents">{{ COL_FIELD.trim() }}</div>',
        cellFilter: 'nfcurrency',
        headerCellClass: 'facilitySpend',
        visibility: _.bind(this.isSeller, this),
        minWidth: 250
      },
      {
        displayName: 'Spend (Last 12 Months)',
        field: 'categorySpend.last12monthSpend', // show this on buyer side only
        // cellTemplate: '<div class="ui-grid-cell-contents">{{ COL_FIELD.trim() }}</div>',
        cellFilter: 'nfcurrency',
        headerCellClass: 'facilitySpend',
        visibility: _.bind(this.isBuyer, this)
      },
      {
        displayName: 'Savings',
        field: 'savings',
        cellFilter: 'nfcurrency',
        headerCellClass: 'facilitySavings'
      },
      {
        displayName: 'GLN #',
        field: 'gln',
        headerCellClass: 'facilityGLN'
      },
      {
        displayName: 'Address',
        enableSorting: false,
        field: 'address1',
        minWidth: 330,
        cellTemplate:
          '<div class="ui-grid-cell-contents">{{ row.entity.address1 }}{{ row.entity.address2 }} {{ row.entity.city.trim() }}, {{ row.entity.state }} {{ row.entity.zip }}</div>',
        headerCellClass: 'facilityAddress',
        // using custom template because ui-grid was not processing ng-href in header template
        headerCellTemplate: `<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus">
                                <span ng-bind-html="::col.displayName CUSTOM_FILTERS"></span>
                                <a target="_blank"
                                   ng-href="{{::grid.appScope.$ctrl.downloadLink()}}"
                                   class="ss-icon ss-download apt-green apt-green-hover">
                                </a>
                              </div>`
      }
    ]
  };

  constructor(
    private uiGridConstants,
    private headerCellTemplate,
    private $filter
  ) {
    'ngInject';
  }

  $onInit() {
    if (this.account.isSeller && !this.tierId) {
      // console.log('tierId is required for seller side');
    }

    this.gridOptions.data = this.getFacilities(this.facilities);

    this.calculateColumnVisibility(this.gridOptions.columnDefs);
  }

  $onChanges(changes) {
    if (changes.facilities) {
      this.gridOptions.data = this.getFacilities(this.facilities);
    }
  }

  isSeller(column) {
    column.visible = this.account.isSeller;
  }

  isBuyer(column) {
    column.visible = this.account.isBuyer;
  }

  calculateColumnVisibility(columnDefs) {
    _.each(columnDefs, (column: any) => {
      if (column.visibility) {
        column.visibility(column);
      }
    });
  }

  getFacilities(newFacilities) {
    let facilities = _.clone(newFacilities);

    _.each(newFacilities, (facility: any) => {
      _.each(facility.children, (childFacility) => {
        facilities.push(childFacility);
      });
    });

    // The old facilities api needed this, but the new one may not
    // If we have issues with null values, just add this back

    // Update numbers on the root
    // this.fixNullCategorySpendNumbers(facilities[0]);

    // _.each(facilities[0].children, _.bind(this.fixNullCategorySpendNumbers, this));

    // return facilities;  // for testing let's show them all

    return this.$filter('filterZeroSpendAndZeroSavings')(facilities);
  }

  // Probably safe to remove this
  // fixNullCategorySpendNumbers (facility) {
  //   var categorySpend = facility.categorySpend;

  //   categorySpend.categoryPotentialSpend = categorySpend.categoryPotentialSpend || 0;
  //   categorySpend.categoryPotentialSpend = categorySpend.categoryPotentialSpend || 0;
  //   categorySpend.categorySavings = categorySpend.categorySavings || 0;
  //   categorySpend.crossReferenceSpend = categorySpend.crossReferenceSpend || 0;
  //   categorySpend.last12monthSpend = categorySpend.last12monthSpend || 0;
  //   categorySpend.next12monthSpend = categorySpend.next12monthSpend || 0;
  //   categorySpend.spendWithSeller = categorySpend.spendWithSeller || 0;
  // }

  downloadLink() {
    if (this.account.isBuyer) {
      // console.log('Puck:');
      // console.log(this.puck);
      return (
        '/aptitude/buyer/GroupImpactServiceController/downloadFacilities?isGroupRequest=false' +
        '&includeSavings=true' +
        '&buyerId=' +
        this.puck.id + // member id
        '&categoryId=' +
        this.rfp.category.id +
        '&requestId=' +
        this.rfp.id +
        '&sellerId=' +
        this.puck.activeSeller.id
      );
    } else {
      return (
        '/aptitude/seller/SellerPricingViewServiceController/downloadFacilities?buyerId=' +
        this.puck.id +
        '&categoryId=' +
        this.rfp.category.id +
        '&isGroupRequest=false' +
        '&requestId=' +
        this.rfp.id +
        '&includeSavings=true' +
        '&offerId=' +
        this.offerId +
        '&tierId=' +
        this.tierId +
        '&usePrimaryCrosses=' +
        this.usePrimaryEquivalentCrosses
      );
    }
  }

  calculateHeight() {
    let colHeight = 30;
    let rows = this.gridOptions.data.length;
    let gridRows = rows > this.maxRowsToShow ? this.maxRowsToShow : rows;

    return this.gridOptions.rowHeight * gridRows + colHeight;
  }

  adjustGridHeight() {
    return {
      height: this.calculateHeight() + 'px'
    };
  }
}

export const SavingsPuckFacilitiesComponent = {
  template: require('./savingsPuckFacilities.component.html'),
  controller: SavingsPuckFacilitiesCtrl,
  bindings: {
    account: '<',
    rfp: '<',
    puck: '<',
    offerId: '<',
    tierId: '<',
    facilities: '<',
    usePrimaryEquivalentCrosses: '<'
  }
};
